module.exports = __webpack_public_path__ + "img/verdi_brand_logo.ff7fc5a7.png";